// ThemeManagement.tsx
// テーマ管理ページのエントリーポイント

import * as React from 'react';
import ThemeList from './Components/ThemeList';
import CustomMenu from '../../components/CustomMenu/CustomMenu';

/**
 * テーマ管理ページコンポーネント
 * - カスタムメニュー内にテーマ一覧を表示する
 */
export default function ThemeManagement() {
  return (
    <CustomMenu>
      <ThemeList />
    </CustomMenu>
  );
}
